import axios from '@/plugins/axios';
import utils from '@/stores/utils';

const { loadFiltersFromStorage, saveFiltersToStorage } = utils;

const DEFAULT_FILTERS = { offset: 0, limit: 20, ordering: 'customer_name' };

const createState = (options = {}) => ({
    catalog: {},
    catalogassignments: [],
    catalogassignments_count: 0,
    catalogassignments_filters: DEFAULT_FILTERS,
    catalogassignments_loaded: false,
    catalogassignments_loading: false,
    catalogassignments_loading_errors: null,
    cancelTokenSource: null,
    _storageOptions: options || {},
});


const mutations = {

    updateCatalog(state, catalog) {
        state.catalog = catalog;
        state.catalogassignments = [];
        state.catalogassignments_count = 0;
        state.catalogassignments_loaded = false;
        state.catalogassignments_loading = false;
        state.catalogassignments_filters = { offset: 0, limit: 20, catalog: catalog ? catalog.id : null, ordering: 'customer_name' };
    },
    updateCatalogAssignments(state, catalogassignments) {
        state.catalogassignments = catalogassignments;
        state.catalogassignments_loaded = true;
        state.catalogassignments_loading = false;
    },
    updateCatalogAssignmentsCount(state, count) {
        state.catalogassignments_count = count;
    },
    updateCatalogAssignmentsLoading(state, loading) {
        state.catalogassignments_loading = loading;
    },
    updateCatalogAssignmentsLoadingErrors(state, errors) {
        state.catalogassignments_loading_errors = errors;
    },
    updateCatalogAssignmentDeleting(state, deleting) {
        state.catalog_deleting_assignment = deleting;
    },
    updateCatalogAssignmentDeletingErrors(state, errors) {
        state.catalog_deleting_assignments_errors = errors;
    },
    updateCatalogAssignmentsFilters(state, filters) {
        state.catalogassignments_filters = filters;
        const { storageKey, fieldsToSave } = state._storageOptions;
        if (storageKey) {
            saveFiltersToStorage(storageKey, state.catalogassignments_filters, fieldsToSave);
        }
    },
    updateCancelTokenSource(state, source) {
        state.cancelTokenSource = source;
    },
    updateStorageOptions(state, storage_options) {
        state._storageOptions = storage_options;
    },
};


const getters = {

};

const actions = {

    async fetchCatalogAssignments({ commit, dispatch, state }, params) {
        // Cancel any pending request
        if (state.cancelTokenSource) {
            state.cancelTokenSource.cancel("New fetch started");
        }

        // Create new cancel token source
        const source = axios.CancelToken.source();
        commit('updateCancelTokenSource', source);

        commit('updateCatalogAssignmentsLoading', true);
        commit('updateCatalogAssignmentsLoadingErrors', null);

        try {
            const response = await axios.get("/api/catalogassignments/", {
                params: state.catalogassignments_filters,
                cancelToken: source.token,
            });
            commit('updateCatalogAssignments', response.data.results);
            commit('updateCatalogAssignmentsCount', response.data.count);
            return response.data.payload;
        } catch (xhr_error) {
            // Ignore cancelled requests
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit('updateCatalogAssignmentsLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateCatalogAssignmentsLoading', false);
        }
    },

    async deleteCatalogAssignment({ commit, dispatch, state }, params) {
        commit('updateCatalogAssignmentDeleting', true);
        commit('updateCatalogAssignmentDeletingErrors', null);

        const url = `/api/catalogassignments/${params.instance.id}/`;

        try {
            const response = await axios.delete(url);
            commit('updateCatalogAssignmentDeleting', false);
            return response.data.payload;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateCatalogAssignmentDeleting', false);
            commit('updateCatalogAssignmentDeletingErrors', error.details);
            throw error;
        }
    },

    async init({ commit, dispatch, state }, params) {
        commit('updateCatalog', params.catalog);
        
        // Update storage options if provided
        if (params.storageOptions !== undefined) {
            await commit('updateStorageOptions', params.storageOptions);
        }
        
        // Load filters from localStorage if storage is configured
        await commit('updateCatalogAssignmentsFilters', { 
            ...DEFAULT_FILTERS, 
            ...(state._storageOptions?.storageKey ? loadFiltersFromStorage(state._storageOptions?.storageKey, {}) : {}),
            ...(params.filters || {}),
        });
    }
};

export default (options = {}) => ({
    namespaced: true,
    state: createState(options),
    mutations,
    actions
});